import { Alert as AlertBase } from 'antd';
import { AlertProps } from 'antd/lib/alert';
import React from 'react';

export interface IAlertProps extends AlertProps {}

const Alert: React.FC<IAlertProps> = ({ ...props }) => {
  return <AlertBase {...props} />;
};

export default Alert;
